import { call, put, takeLatest } from "redux-saga/effects";
import { fetchAllSection } from "../../../services/section";
import {
  getAllSectionFailure,
  getAllSectionStart,
  getAllSectionSuccess,
} from "../reducer";

export function* getSections({ payload }) {
  const response = yield call(fetchAllSection, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getAllSectionSuccess(raw));
  } else {
    yield put(getAllSectionFailure(message || raw.error));
  }
}

export default function* onGetAllSection() {
  yield takeLatest(getAllSectionStart.type, getSections);
}
